import axios from 'axios'
import Swal from 'sweetalert2'
import appConfig from '../../app.config'

function createInstance() {
  return axios.create({
    baseURL: appConfig.baseURL,
    headers: {
      'Content-Type': 'application/json;charset=utf-8',
      accept: 'application/json',
    },
  })
}

export const instance = createInstance()

//인터셉터 공통 처리
instance.interceptors.response.use(
  (response) => {
    if (response.status == '200') {
      return response
    } else {
      // 서버 응답은 200으로 성공했는데, 내용은 실패일 때 (비즈니스 로직 에러)
      Swal.fire('처리 중 오류!', '시스템 관리자에게 문의하세요.', 'error')
      return response
    }
  },

  /**
   * HTTP 상태 코드가 200번대가 아닐 때 실행
   */
  (error) => {
    Swal.fire(
      '요청 실패',
      '서버 통신 중 문제가 발생 했습니다. 시스템 관리자에게 문의하세요.',
      'error'
    )
    return error
  }
)
